import {Component, Prop, Vue, Emit, Watch} from 'vue-property-decorator';
import Service from '../../../../common/src/assets/service/service';
import Common from '../../../../common/src/assets/js/common';
import Constant from '../../../../common/src/assets/constant/constant';

const echarts = require('../../../../common/src/assets/plugins/echarts/echarts.js');
const moment = require('../../../../common/src/assets/moment/moment');
declare var $: any;
@Component({
    filters: {
        consumeDayText(value: number, type: string = 'name') {
            if (value >= 3) {
                return type === 'name' ? '安全' : 'color-success';
            } else if (value === 2) {
                return type === 'name' ? '注意' : 'color-warning';
            } else if (value < 2) {
                return type === 'name' ? '预警' : 'color-danger';
            } else {
                return type === 'name' ? '安全' : 'color-success';
            }
        },
        consumeDayColor(value: number, type: string = 'color'){

        },
        companyVeriyedStatus(value: number) {
            switch(value) {
                case -1:
                    return '企业认证失败';
                case -2:
                    return '企业认证审核中';
                case -3:
                    return '企业认证待审核';
                case 1:
                    return '企业认证成功';
                case 0:
                    return '未进行企业认证';
                default:
                    return '未进行企业认证';
            }
        }
    }
})
export default class General extends Vue {
    public $store: any;
    public $route: any;
    public $router: any;
    private $platform: any;
    private userID: string = '';
    private resourceList: any = [
        {key: 'vmCount', dataKey:'vmData', uuid:'', name: '云服务器',image: 'general-resource-vm.png', count: 0, tipsCount: 0, link: '/resource/vm/list'},
        {key: 'diskCount', dataKey:'diskData', uuid:'', name: '云磁盘',image: 'general-resource-disk.png', count: 0, tipsCount: 0, link: '/resource/disk/list'},
        {key: 'snapCount', dataKey:'snapData', uuid:'', name: '云快照',image: 'general-resource-snap.png', count: 0, tipsCount: 0, link: '/resource/snap/list'},
        {key: 'imageCount', dataKey:'imageData', uuid:'', name: '镜像',image: 'general-resource-mirror.png', count: 0, tipsCount: 0, link: '/resource/mirror/list'},
        {key: 'ipCount', dataKey:'ipData', uuid:'', name: '弹性公网IP',image: 'general-resource-ip.png', count: 0, tipsCount: 0, link: '/resource/ip/list'},
        {key: 'vpcCount', dataKey:'', uuid:'', name: 'VPC虚拟私有云',image: 'general-resource-vpc.png', count: 0, tipsCount: 0, link: '/resource/vpc/list'},
        {key: 'securityGroupCount', dataKey:'', uuid:'', name: '安全组',image: 'general-resource-group.png', count: 0, tipsCount: 0, link: '/resource/securityGroup/list'},
        {key: 'natCount', dataKey:'natData', uuid:'', name: 'NAT网关',image: 'general-resource-nat.png', count: 0, tipsCount: 0, link: '/resource/nat/list'},
        // {key: 'none', dataKey:'', uuid:'', name: '共享带宽包',image: 'general-resource-bwPackage.png', count: 0, tipsCount: 0, link: '/resource/vm/list'},
        {key: 'slbCount', dataKey:'slbData', uuid:'', name: 'SLB负载均衡',image: 'general-resource-slb.png', count: 0, tipsCount: 0, link: '/resource/slb/list'},
        {key: 'rdsCount', dataKey:'rdsData', uuid:'', name: 'RDS云数据库',image: 'general-resource-rds.png', count: 0, tipsCount: 0, link: '/resource/rds/list'},
        // {key: 'none', dataKey:'', uuid:'', name: '弹性网卡',image: 'general-resource-vif.png', count: 0, tipsCount: 0, link: '/resource/vm/list'},
    ]
    private resourceSelectTimeList: any = [
        {text: '提示一周内待续费信息', value: 7},
        {text: '提示一月内待续费信息', value: 30},
    ];
    private status: any = {
        resourceSelectTime: 7,      // 资源使用情况查询时间
        isConsume: false,           // 是否具有消费
    }
    private time: any = {
        thisMonth: '',
        lastMonth: '',
        thisMonthStart: '',
        thisMonthEnd: '',
        lastMonthStart: '',
        lastMonthEnd: '',
        lastAugustStart: '',
        lastAugustEnd: '',
    }
    /**消费金额 */
    private consume: any = {
        thisMonth: 0,
        lastMonth: 0,
        today: 0,
        balanceDay: 0,
    }
    private loading: any = {
        echart: '',
        bulletin: '',
        resource: '',
    }
    private showEchart: any = false;
    private bulletinList: any = [];     // 公告列表
    private userInfo: any = {};         // 用户基础信息
    private userBalance: any = 0;       // 用户余额信息
    private get consumeDay() {          // 足够n天消费
        return Math.floor(this.userBalance / this.consume.today);
    }
    private get consumeColor() {
        if (this.consumeDay >= 3) {
            return  '#62CE92';
        } else if (this.consumeDay === 2) {
            return '#e6a23c';
        } else if (this.consumeDay < 2) {
            return '#f56c6c';
        } else {
            return '#62CE92';
        }
    }
    private get consumeWidth() {
        if (this.status.isConsume && this.consumeDay >= 3) {
            return  '100';
        } else if (this.status.isConsume &&this.consumeDay === 2) {
            return '60';
        } else if (this.status.isConsume &&this.consumeDay < 2) {
            return '30';
        } else {
            return '0';
        }
    }

    @Watch('$store.state.userInfo', {immediate: true})
    getUserInfoState(val: any) {
        if (val) {
            this.userInfo = val;
        }
    }
    private created() {
        this.userID = Common.getUserID(this.$platform);
        this.time.thisMonth = moment().startOf('month').format('YYYY-MM');
        this.time.lastMonth = moment().month(moment().month() - 1).startOf('month').format("YYYY-MM");
        this.time.thisMonthStart = moment().startOf('month').format("YYYY-MM-DD HH:mm:ss");
        this.time.thisMonthEnd = moment().format('YYYY-MM-DD HH:mm:ss');
        this.time.lastMonthStart = moment().month(moment().month() - 1).startOf('month').format("YYYY-MM-DD HH:mm:ss");
        this.time.lastMonthEnd = moment().month(moment().month() - 1).endOf('month').format("YYYY-MM-DD HH:mm:ss");
        this.time.lastAugustStart = moment().month(moment().month() - 7).startOf('month').format("YYYY-MM-DD HH:mm:ss");
        this.time.lastAugustEnd = moment().format('YYYY-MM-DD HH:mm:ss');
        this.getBalance();
        this.getCurrentConsume();
        this.getBulletin();
        this.getResourceRenewData();
        this.getResourceUseData();
        // this.getAllMonthlyBills();
        this.getMonthlyBills();
    }
    mounted() {
        // this.getAllMonthlyBills();
        // this.getMonthlyBills();
    }

    private selectChange($event: any, type: string) {
        switch(type) {
            case 'resourceSelectTime':
                this.status.resourceSelectTime = $event.value;
                this.getResourceRenewData();
                break;
        }
    }

    /**最近8个月echart图数据 */
    private initEcharts(data: any) {
        let monthArr = [];
        let xAxisArr = [];
        let seriesdata: any = []
        for (let i = 7; i>=0; i--) {
            let yyyyMM = moment().month(moment().month() - i).startOf('month').format("YYYY-MM");
            let month = moment().month(moment().month() - i).month();
            xAxisArr.push(month + 1 + '月');
            monthArr.push(yyyyMM);
        }
        monthArr.forEach((mm: string) => {
            seriesdata.push(data[mm] ? data[mm].consumeSummary : 0);
        })
        let option = {
            xAxis: {
                type: 'category',
                data: xAxisArr,
            },
            yAxis: {
                type: 'value'
            },
            grid: {
                top: '10px',
                left: '0',
                right: '0',
                bottom: '0',
                containLabel: true
            },
            color: '#41B2DC',
            series: [
                {
                    data: seriesdata,
                    type: 'bar',
                },
            ],
            tooltip: {
                trigger:'axis',
                axisPointer: {
                    type:'cross',
                    crossStyle: {
                        color:'#999'
                    }
                },
                formatter:function (params: any) {
                    // console.log(params); // 当我们想要自定义提示框内容时，可以先将鼠标悬浮的数据打印出来，然后根据需求提取出来即可
                    return params[0].value;
                }
            },
        };

        let myEcharts = echarts.init(document.getElementById('canvas-comsumed-sum'))
        myEcharts.setOption(option);
        let delay = setTimeout(()=>{
            myEcharts.resize();
            clearTimeout(delay)
        }, 100)
        window.onresize = function () {
            myEcharts.resize();
        };
    }

    private skip(link: string) {
        this.$router.push(link);
    }

    /**获取资源待续费 */
    private getResourceRenewData() {
        let params = {
            userID: this.userID,
            duration: this.status.resourceSelectTime,
        };
        this.loading.resource = 'loading';
        this.resourceList.forEach((item: any) => {item.tipsCount = 0})
        Service.request('/user/getUserResourceRenewal', params, 'token')
            .then((res: any) => {
                let data = res.data;
                this.loading.resource = 'havedata';
                this.resourceList.forEach((item: any) => {
                    if (data[item.key]) {
                        item.tipsCount = data[item.key];
                        item.uuid = data[item.dataKey];
                    } else {
                        item.tipsCount = 0;
                    }
                })
            })
            .catch(error => {
                this.loading.resource = 'nodata';
            });
    }

    /**获取资源使用情况 */
    private getResourceUseData() {
        let params = {
            userID: this.userID,
        };
        Service.request('/user/getUserResourceSummary', params, 'token')
            .then((res: any) => {
                let data = res.data;
                this.resourceList.forEach((item: any) => {
                    if (data[item.key]) {
                        item.count = data[item.key];
                    } else {
                        item.count = 0;
                    }
                })
            })
            .catch(error => {
            });
    }
    /**获取月度账单 */
    private getMonthlyBills() {
        let params = {
            userID: this.userID,
            createTimeStart: this.time.lastAugustStart,
            createTimeEnd: this.time.lastAugustEnd,
            monthTime: '',  // 2020-09
        };
        this.loading.echart = "loading";
        Service.request('/user/getUserMonthBillSummary', params, 'token')
            .then((res: any) => {
                let data = res.data;
                // resolve && resolve(data)
                console.log('132data', data)
                if (data.length !== 0) {
                    this.loading.echart = "havedata";
                    this.consume.thisMonth = data[this.time.thisMonth] && data[this.time.thisMonth]['consumeSummary'];
                    this.consume.lastMonth = data[this.time.lastMonth] && data[this.time.lastMonth]['consumeSummary'];
                    this.initEcharts(data);
                    this.showEchart = true;
                } else {
                    this.loading.echart = "nodata";
                    this.showEchart = false;

                }
            })
            .catch(error => {
                // reject && reject(error);
                console.log(error)
                this.loading.echart = "nodata";
                this.showEchart = false;
            });
    }
    /** 获取最近8月账单*/
    private getAllMonthlyBills() {
        new Promise((resolve: any, reject: any) => {
            this.loading.echart = "loading";
            // this.getMonthlyBills(resolve, reject, this.time.lastAugustStart, this.time.lastAugustEnd);
        }).then((data: any) => {
            console.log('this.loading.echart', this.loading.echart);
            console.log('data', data)
            this.loading.echart = "havedata";
            this.showEchart = true;
            this.consume.thisMonth = data[this.time.thisMonth]['consumeSummary'];
            this.consume.lastMonth = data[this.time.lastMonth]['consumeSummary'];
            this.initEcharts(data);
        }).catch(error => {
            console.log(error)
            this.loading.echart = "nodata";
            this.showEchart = false;
        })
    }

    /**获取用户信息 */
    private getUserInfo() {
        let params = {
            userID: this.userID,
        };
        Service.request('/user/queryCustomerInfo', params, 'token')
            .then((res: any) => {
                let data = res.data;
                this.userInfo = data;
            })
            .catch(error => {
            });
    }

    /**获取余额信息 */
    private getBalance() {
        let params = {
            userID: this.userID,
        };
        Service.request('/user/getUserBalance', params, 'token')
            .then((res: any) => {
                let data = res.data;
                this.userBalance = data.balance;
            })
            .catch(error => {
            });
    }

    /**获取公告信息 */
    private getBulletin() {
        let params = {
            userID: this.userID,
            limitStart: 0,
            limitCount: 4,
            isShowBYTime: '1'
        };
        this.loading.bulletin = 'loading';
        Service.request('/user/bulletin/query', params, 'token')
            .then((res: any) => {
                let data = res.data;
                this.loading.bulletin = data.count > 0 ? 'havedata' : 'nodata';
                this.bulletinList = data.list;
            })
            .catch(error => {
                this.loading.bulletin = 'nodata';
            });
    }
    /**获取用户消费情况 */
    private getCurrentConsume() {
        let params = {
            userID: this.userID,
        };
        Service.request('/user/getUserCurrentConsume', params, 'token')
            .then((res: any) => {
                let data = res.data;
                this.consume.today = data;
                this.status.isConsume = Number(data) !== 0;
            })
            .catch(error => {
            });
    }
}
